export enum SplitDirection {
  Vertical = 'vertical',
  Horizontal = 'horizontal',
}
